import { render, staticRenderFns } from "./updateDialog.vue?vue&type=template&id=2ff0330b&lang=pug"
import script from "./updateDialog.vue?vue&type=script&lang=ts"
export * from "./updateDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports